import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  mergeRow,
  safeText,
  setCell,
  toYesNo,
} from "./principle6SheetHelpers";
import { filterPopulatedRows, setStandardDetailWidths } from "./principle8SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "Details of the benefits from IP";

const SHEET_TITLE =
  "Details of the benefits derived and shared from the intellectual properties owned or acquired by your entity (in the current financial year), based on traditional knowledge";

export function buildDetailsOfBenefitsFromIPSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  setStandardDetailWidths(ws, { D: 8, E: 24, F: 16, G: 16, H: 22 });

  const rows = filterPopulatedRows(
    sectionC?.principle8?.leadershipIndicator?.traditionalKnowledgeIntellectualProperties,
    [
      "ipBasedOnTraditionalKnowledge",
      "ownedAcquired",
      "benefitShared",
      "basisOfCalculatingBenefitShare",
    ]
  );

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_8, { mergeEnd: COL_H });

  mergeRow(ws, TITLE_ROW, COL_D, COL_H, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr.No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Intellectual Property based on traditional knowledge", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_F, "Owned/ Acquired (Yes/No)", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_G, "Benefit shared (Yes/ No)", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });
  setCell(ws, HEADER_ROW, COL_H, "Basis of calculating benefit share", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, safeText(item?.ipBasedOnTraditionalKnowledge), { align: "left" });
    setCell(ws, row, COL_F, toYesNo(item?.ownedAcquired), { align: "center" });
    setCell(ws, row, COL_G, toYesNo(item?.benefitShared), { align: "center" });
    setCell(ws, row, COL_H, safeText(item?.basisOfCalculatingBenefitShare, ""), { align: "left" });
  });

  return ws;
}
